// extracted by mini-css-extract-plugin
export default {"nav":"Chip_nav__Pf4me"};